import React, { useEffect, useState } from 'react';
import { Card, Btn, Input, Field, Select, Modal, Table, Spinner, ErrBox } from '../../../components/UI';
import { contractAPI, masterAPI } from '../../../utils/api';
import { fmtRp } from '../../../utils/format';

const levelBadge = (val, color) => val ? (
  <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${color}22`, color, border: `1px solid ${color}44` }}>{val}</span>
) : null;
const ProgramBadge = ({v}) => levelBadge(v, "#7C3AED");
const KegiatanBadge = ({v}) => levelBadge(v, "#D97706");
const KroBadge = ({v}) => levelBadge(v, "#059669");

const emptyForm = {
  contract_no: '', vendor_id: '', judul: '', deskripsi: '', tipe_kontrak: 'KONTRAK',
  nilai_kontrak: '', mata_uang: 'IDR', tanggal_mulai: '', tanggal_selesai: '',
  penanggung_jawab: '', no_dokumen: '', akun_id: '', coa_detail_id: '', sumber_dana_id: '',
  _selectedAkun: null,
};

export default function KontrakFormTab({ onSuccess, editId }) {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editId) {
      setLoading(true);
      contractAPI.getById(editId).then(r => {
        const d = r.data;
        setForm({
          contract_no: d.contract_no || '', vendor_id: d.vendor_id || '', judul: d.judul || '',
          deskripsi: d.deskripsi || '', tipe_kontrak: d.tipe_kontrak || 'KONTRAK',
          nilai_kontrak: d.nilai_kontrak || '', mata_uang: d.mata_uang || 'IDR',
          tanggal_mulai: d.tanggal_mulai?.split('T')[0] || '', tanggal_selesai: d.tanggal_selesai?.split('T')[0] || '',
          penanggung_jawab: d.penanggung_jawab || '', no_dokumen: d.no_dokumen || '',
          akun_id: d.akun_id || '', coa_detail_id: d.coa_detail_id || '', sumber_dana_id: d.sumber_dana_id || '',
          _selectedAkun: d.akun_id ? (() => {
            return { program_kode: d.program_kode, program_nama: d.program_nama, kegiatan_kode: d.kegiatan_kode, kegiatan_nama: d.kegiatan_nama, kro_kode: d.kro_kode, kro_nama: d.kro_nama };
          })() : null,
        });
      }).catch(() => {}).finally(() => setLoading(false));
    }
  }, [editId]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [refVendor, setRefVendor] = useState([]);
  const [refAkun, setRefAkun] = useState([]);
  const [refCoaDetail, setRefCoaDetail] = useState([]);
  const [refSumberDana, setRefSumberDana] = useState([]);

  useEffect(() => {
    masterAPI.getVendor().then(r => setRefVendor((r.data||[]).map(v => ({ value: v.id, label: `${v.kode} - ${v.nama}` })))).catch(() => {});
    masterAPI.getCoaAkun().then(r => setRefAkun((r.data||[]).map(x => ({
      value: x.id, label: `${x.kode} - ${x.nama}`,
      program_kode: x.program_kode, program_nama: x.program_nama,
      kegiatan_kode: x.kegiatan_kode, kegiatan_nama: x.kegiatan_nama,
      kro_kode: x.kro_kode, kro_nama: x.kro_nama,
    })))).catch(() => {});
    masterAPI.getCoaDetailAkun().then(r => setRefCoaDetail((r.data||[]).map(x => ({ value: x.id, label: `${x.kode} - ${x.nama}`, akun_id: x.akun_id })))).catch(() => {});
    masterAPI.getSumberDana().then(r => setRefSumberDana((r.data||[]).map(s => ({ value: s.id, label: s.nama })))).catch(() => {});
  }, []);

  const handleChange = (field, value) => {
    setForm(prev => {
      if (field === 'akun_id') {
        return { ...prev, akun_id: value, coa_detail_id: '', _selectedAkun: null };
      }
      return { ...prev, [field]: value };
    });
  };

  useEffect(() => {
    if (refAkun.length > 0 && form.akun_id && !form._selectedAkun) {
      const a = refAkun.find(x => x.value === form.akun_id);
      if (a) setForm(prev => ({ ...prev, _selectedAkun: { program_kode: a.program_kode, program_nama: a.program_nama, kegiatan_kode: a.kegiatan_kode, kegiatan_nama: a.kegiatan_nama, kro_kode: a.kro_kode, kro_nama: a.kro_nama } }));
    }
  }, [refAkun, form.akun_id]);

  const selectedAkun = form._selectedAkun || refAkun.find(x => x.value === form.akun_id);
  const filteredCoaDetail = form.akun_id ? refCoaDetail.filter(d => String(d.akun_id) === String(form.akun_id)) : [];
  const selectedCoaDetail = refCoaDetail.find(d => d.value === form.coa_detail_id);

  const handleSave = async () => {
    if (!form.contract_no || !form.vendor_id || !form.judul) return alert('No. Kontrak, Vendor, dan Judul wajib diisi');
    setSaving(true);
    setError('');
    try {
      const payload = {
        contract_no: form.contract_no, vendor_id: form.vendor_id, judul: form.judul,
        deskripsi: form.deskripsi || null, tipe_kontrak: form.tipe_kontrak,
        nilai_kontrak: form.nilai_kontrak || 0, mata_uang: form.mata_uang,
        tanggal_mulai: form.tanggal_mulai || null, tanggal_selesai: form.tanggal_selesai || null,
        penanggung_jawab: form.penanggung_jawab || null, no_dokumen: form.no_dokumen || null,
        akun_id: form.akun_id || null, coa_detail_id: form.coa_detail_id || null, sumber_dana_id: form.sumber_dana_id || null,
      };
      if (editId) {
        await contractAPI.update(editId, payload);
      } else {
        await contractAPI.create(payload);
      }
      onSuccess();
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  return (
    <Card style={{ padding: 24 }}>
      <h3 style={{ margin: '0 0 20px', fontSize: 15, fontWeight: 600 }}>Form Kontrak</h3>
      {error && <ErrBox msg={error} />}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Field label="No. Kontrak" required>
          <Input value={form.contract_no} onChange={e => handleChange('contract_no', e.target.value)} placeholder="KTR-2026-001" />
        </Field>
        <Field label="Vendor" required>
          <Select value={form.vendor_id} onChange={e => handleChange('vendor_id', e.target.value)} options={refVendor} placeholder="Pilih vendor…" />
        </Field>
      </div>

      <Field label="Judul Kontrak" required>
        <Input value={form.judul} onChange={e => handleChange('judul', e.target.value)} placeholder="Judul/pernyataan kontrak" />
      </Field>

      <Field label="Deskripsi">
        <textarea value={form.deskripsi} onChange={e => handleChange('deskripsi', e.target.value)} rows={3} placeholder="Deskripsi kontrak…" style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', resize: 'vertical', outline: 'none' }} />
      </Field>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
        <Field label="Tipe Kontrak">
          <Select value={form.tipe_kontrak} onChange={e => handleChange('tipe_kontrak', e.target.value)} options={[
            { value: 'KONTRAK', label: 'Kontrak' },
            { value: 'MOU', label: 'MOU' },
            { value: 'PKS', label: 'PKS' },
            { value: 'SPK', label: 'SPK' },
          ]} />
        </Field>
        <Field label="Nilai Kontrak">
          <Input value={form.nilai_kontrak} onChange={e => handleChange('nilai_kontrak', e.target.value)} placeholder="0" type="number" />
        </Field>
        <Field label="Mata Uang">
          <Select value={form.mata_uang} onChange={e => handleChange('mata_uang', e.target.value)} options={[
            { value: 'IDR', label: 'IDR (Rupiah)' },
            { value: 'USD', label: 'USD (Dollar)' },
            { value: 'EUR', label: 'EUR (Euro)' },
          ]} />
        </Field>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Field label="Tanggal Mulai">
          <Input value={form.tanggal_mulai} onChange={e => handleChange('tanggal_mulai', e.target.value)} type="date" />
        </Field>
        <Field label="Tanggal Selesai">
          <Input value={form.tanggal_selesai} onChange={e => handleChange('tanggal_selesai', e.target.value)} type="date" />
        </Field>
      </div>

      <Field label="Penanggung Jawab">
        <Input value={form.penanggung_jawab} onChange={e => handleChange('penanggung_jawab', e.target.value)} placeholder="Nama penanggung jawab" />
      </Field>

      <Field label="No. Dokumen">
        <Input value={form.no_dokumen} onChange={e => handleChange('no_dokumen', e.target.value)} placeholder="Nomor dokumen perjanjian" />
      </Field>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Field label="Akun MA">
          <Select value={form.akun_id} onChange={e => handleChange('akun_id', e.target.value)} options={refAkun} placeholder="Pilih Akun MA…" />
        </Field>
        <Field label="Sumber Dana">
          <Select value={form.sumber_dana_id} onChange={e => handleChange('sumber_dana_id', e.target.value)} options={refSumberDana} placeholder="Pilih Sumber Dana…" />
        </Field>
      </div>

      {selectedAkun && (
        <div style={{ marginBottom: 16, padding: 10, background: '#F8FAFC', borderRadius: 8, fontSize: 12, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <ProgramBadge v={selectedAkun.program_kode ? `${selectedAkun.program_kode} - ${selectedAkun.program_nama}` : null} />
          <KegiatanBadge v={selectedAkun.kegiatan_kode ? `${selectedAkun.kegiatan_kode} - ${selectedAkun.kegiatan_nama}` : null} />
          <KroBadge v={selectedAkun.kro_kode ? `${selectedAkun.kro_kode} - ${selectedAkun.kro_nama}` : null} />
        </div>
      )}

      {form.akun_id && (
        <Field label="Detail COA">
          <Select value={form.coa_detail_id} onChange={e => handleChange('coa_detail_id', e.target.value)} options={refCoaDetail.length > 0 ? filteredCoaDetail : []} placeholder={refCoaDetail.length === 0 ? "Memuat..." : "Pilih Detail COA…"} />
        </Field>
      )}

      {selectedCoaDetail && (
        <div style={{ marginBottom: 16, padding: 10, background: '#EFF6FF', borderRadius: 8, fontSize: 12, color: '#1D4ED8' }}>
          {selectedCoaDetail.label}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
        <Btn variant="secondary" onClick={onSuccess}>Batal</Btn>
        <Btn onClick={handleSave} disabled={saving}>{saving ? 'Menyimpan…' : 'Simpan Kontrak'}</Btn>
      </div>
    </Card>
  );
}
